export const isTouchDevice = 'ontouchstart' in globalThis || globalThis?.navigator?.maxTouchPoints > 0;
